// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprSinLogoSt3App extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.sin_logo.st_3_app";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprSinLogoSt3App {
        this.VALUES ??= this.completar({
            "valor": {
                "en": "Reject cookie-like technologies",
                "es": "Rechazar tecnologías similares a cookies"
            },
            "defecto": "Reject cookie-like technologies"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
